module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-100-Classes-Inactive-e06839b5740be187f6fca79cb112d26f.png";